<template>
  <div
    style="
      margin-bottom: 0.9375rem;
      position: absolute;
      z-index: 100;
      width: 100%;
      background-color: rgba(234, 255, 252, 0.85) !important;
      border-bottom: 1px solid #0086fb;
    "
  >
    <b-navbar
      toggleable="lg"
      type="light"
      variant="white"
      class="navbar-content"
    >
      <b-navbar-brand href="#" class="nav-logo">
        <img
          src="https://game-cdn.feigo.fun/uploads/20211006/79V9M9uz54uyCYF9R0J6e2CgJj5JE4Dx.png"
        />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav style="flex-grow: 0">
        <b-navbar-nav style="width: -webkit-fit-content">
          <b-nav-item>
            <router-link to="home"
              ><span :class="[$route.path === '/home' ? 'active' : '']"
                >登游首页</span
              ></router-link
            >
          </b-nav-item>
          <b-nav-item href="#">
            <router-link to="about"
              ><span :class="[$route.path === '/about' ? 'active' : '']"
                >关于登游</span
              ></router-link
            >
          </b-nav-item>
          <b-nav-item>
            <router-link to="product"
              ><span :class="[$route.path === '/product' ? 'active' : '']"
                >游戏产品</span
              ></router-link
            >
          </b-nav-item>
          <b-nav-item href="#">
            <router-link to="business"
              ><span :class="[$route.path === '/business' ? 'active' : '']"
                >商务合作</span
              >
            </router-link>
          </b-nav-item>
          <b-nav-item href="#">
            <router-link to="join"
              ><span :class="[$route.path === '/join' ? 'active' : '']"
                >加入登游</span
              ></router-link
            >
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.active {
  color: #0086fb;
}
.navbar {
  padding: 0 1rem;
  width: 80%;
  margin: 0 auto;
  /* height: 100px; */
}
.bg-white {
  background-color: rgba(255, 255, 255, 0) !important;
}
.nav-link {
  padding-top: 0;
}
span {
  font-size: 22px;
}
@media screen and (min-width: 992px) {
  .navbar {
    width: -webkit-fit-content;
    height: 100px;
  }
  .nav-logo {
    margin: 0.5rem 11.25rem;
    margin-left: 0rem;
  }
  a {
    text-decoration: none;
    color: #343a40;
    font-size: 1.125rem;
    display: block;
    width: 108px;
    text-align: center;
    height: 95px;
    float: left;
    margin: 0 0.5rem;
  }
  span {
    display: block;
    width: 100%;
    height: 100%;
    line-height: 5.9375rem;
    color: #000000;
  }
}
@media screen and (max-width: 1472px) and (min-width: 992px) {
  .nav-logo {
    margin: 0.5rem 3rem;
  }
  .navbar {
    padding: 0 1rem;
    width: 80%;
    margin: 0 auto;
    height: 100px;
  }
}
@media screen and (max-width: 991px) {
  .navbar {
    padding: 0 1rem;
    width: 100%;
    margin: 0 auto;
  }
  .nav-logo {
    margin: 0;
  }
  .nav-logo img {
    width: 70%;
  }
  span {
    display: block;
    width: 100%;
    height: 100%;
    line-height: 2rem;
    color: #000000;
    font-size: 17px;
  }
}
</style>
